import React, { Component, createRef } from 'react';
import { Col, Row, Form, Button, Spinner, Modal, Container } from 'react-bootstrap';
import SelectDropDown from '../selectdropdown/SelectDropDown';
import CloseButton from 'react-bootstrap/CloseButton';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import * as Cookies from 'es-cookie';
import * as compose from "lodash.flowright";


const FETCH_EXAMNAMES = gql`
  query ($institute_id: Int!) {
    getOfflineExams(institute_id: $institute_id) {
      id
      exam_name
    }
  }
`;
const OMR_UPLOAD = gql`
  mutation UploadFiles($files: [FileInput!]!, $exam_paper_id: ID, $institute_id: ID) {
    uploadFiles(files: $files, exam_paper_id: $exam_paper_id, institute_id: $institute_id)
  }
`;
class NewOmrUpload extends Component {
  constructor() {
    super();
    this.state = {
      selectedOption1: null,
      examDropDown: [],
      files: [],
      loader: false,
      submitError: '',
      successMessage: '',
      showConfirmModal: false,
    };
    this.fileInputRef = createRef();
  }

  componentDidMount() {
    const { getExamNames } = this.props;

    if (getExamNames && getExamNames.getOfflineExams) {
      const data = getExamNames.getOfflineExams.map((item) => ({
        value: item.id,
        label: item.exam_name,
      }));
      this.setState({ examDropDown: data }, () => {
        console.log("Dropdown data:", this.state.examDropDown);
      });
    }
  }



  componentDidUpdate(prevProps) {
    console.log("inssssss", this.props.getExamNames?.getOfflineExams);

    if (
      this.props.getExamNames?.getOfflineExams &&
      prevProps.getExamNames?.getOfflineExams !== this.props.getExamNames?.getOfflineExams
    ) {
      const data = this.props.getExamNames.getOfflineExams.map((item) => ({
        value: item.id,
        label: item.exam_name,
      }));
      this.setState({ examDropDown: data });
    }
  }

  selecthandleInputChange = (name, value) => {
    const selected = this.state.examDropDown?.find((item) => item.value === value);
    this.setState({ selectedOption1: selected });
  };

  handleChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const validImages = selectedFiles.filter((file) => file.type.startsWith('image/'));

    if (validImages.length !== selectedFiles.length) {
      this.setState({ submitError: "Only image files are allowed." });
      return;
    }

    const totalImages = this.state.files.length + validImages.length;
    if (totalImages > 10) {
      this.setState({ submitError: "You can only upload up to 10 images." });
      return;
    }

    const promises = validImages.map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    });

    Promise.all(promises)
      .then((base64Files) => {
        this.setState((prevState) => ({
          files: [...prevState.files, ...base64Files],
          submitError: '',
        }));
      })
      .catch((error) => {
        console.error("File reading error:", error);
        this.setState({ submitError: "Failed to read files." });
      });
  };

  removeImage = (event, indexToRemove) => {
    event.preventDefault();
    const remainingFiles = this.state.files.filter((_, index) => index !== indexToRemove);
    this.setState({ files: remainingFiles }, () => {
      if (remainingFiles.length === 0 && this.fileInputRef.current) {
        this.fileInputRef.current.value = '';
      }
    });
  };

  omrSubmit = async (e) => {
    e.preventDefault();
    if (!this.state.selectedOption1 || this.state.files.length === 0) {
      this.setState({ submitError: "Please select a test and upload at least one image." });
      return;
    }

    this.setState({ loader: true, submitError: '', successMessage: '' });

    try {
      await this.fileUpload();
      this.setState({
        files: [],
        selectedOption1: null,
        successMessage: "Upload successful!",
        showConfirmModal: false,
      });
      if (this.fileInputRef.current) {
        this.fileInputRef.current.value = "";
      }
      setTimeout(() => this.setState({ successMessage: '' }), 3000);
    } catch (error) {
      const errMsg = error?.graphQLErrors?.map(x => x.message)?.join(", ") || "Upload failed.";
      this.setState({ submitError: errMsg });
    } finally {
      this.setState({ loader: false });
    }
  };

  fileUpload = async () => {
    const uploadedFiles = this.state.files.map((file) => ({ file }));
    await this.props.omrupload({
      variables: {
        files: uploadedFiles,
        exam_paper_id: this.state.selectedOption1.value,
        institute_id: parseInt(Cookies.get("institutionid")),
      },
    });
  };

  render() {
    const { getExamNames } = this.props;
    const loading1 = getExamNames?.loading;
    const error1 = getExamNames?.error;

    if (error1) {
      alert("Server Error. " + error1.message);
      return null;
    }

    return (
      <Container fluid>

        {loading1 ? (
          <Container>
            <Row className="my-2">
              <Col>
                <div className="spinner-border text-primary text-center loading-img-center"></div>
              </Col>
            </Row>
          </Container>
        ) : (

          <>
            <Form.Group className="d-flex flex-wrap">
              <Col lg={3} md={12} sm={12}>
                <Form.Label className="text-uppercase font-weight-bold text-dark mt-2">
                  Exam Name
                </Form.Label>
                <SelectDropDown
                  stateData={this.state.selectedOption1}
                  handleChange={this.selecthandleInputChange}
                  name="exam_type"
                  options={this.state.examDropDown}
                  placeholderName="select exam"
                />
              </Col>

              <Col className="mt-5">
                <Form.Control
                  type="file"
                  multiple
                  accept="image/*"
                  onChange={this.handleChange}
                  ref={this.fileInputRef}
                />
                <p className="mt-2 text-muted">Images selected: {this.state.files.length} / 10</p>
              </Col>
            </Form.Group>

            {this.state.submitError && (
              <div className="text-danger mt-2 mb-2">{this.state.submitError}</div>
            )}

            {this.state.successMessage && (
              <div className="text-success mt-2 mb-2">{this.state.successMessage}</div>
            )}

            <Row className="mt-4">
              {this.state.files.map((src, index) => (
                <Col sm={3} key={index} className="mb-3 position-relative">
                  <div style={{ position: 'absolute', top: -5, right: 12, zIndex: 1 }}>
                    <CloseButton onClick={(e) => this.removeImage(e, index)} />
                  </div>
                  <img
                    src={src}
                    alt={`preview-${index}`}
                    style={{
                      width: '100%',
                      height: '40vh',
                      objectFit: 'fill',
                      border: '1px solid #ccc',
                      borderRadius: '4px',
                    }}
                  />
                </Col>
              ))}
            </Row>

            {this.state.files.length > 0 && this.state.selectedOption1 != null && (
              <div className="d-flex justify-content-end mt-3">
                <Button
                  variant="secondary"
                  style={{
                    background: "#213046",
                    border: 'none',
                  }}
                  onClick={() => this.setState({ showConfirmModal: true })}
                  disabled={this.state.loader}
                >
                  Submit
                </Button>
              </div>
            )}

            <Modal
              show={this.state.showConfirmModal}
              onHide={() => this.setState({ showConfirmModal: false })}
            >
              <Modal.Header closeButton>
                <Modal.Title>Confirm Upload</Modal.Title>
              </Modal.Header>
              <Modal.Body>Are you sure you want to upload the files?</Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={() => this.setState({ showConfirmModal: false })}
                >
                  No
                </Button>
                <Button
                  variant="secondary"
                  style={{
                    background: "#213046",
                    border: "none",
                  }}
                  onClick={this.omrSubmit}
                  disabled={this.state.loader}
                >
                  {this.state.loader ? (
                    <>
                      <Spinner animation="border" size="sm" role="status" className="me-2" />
                      Uploading...
                    </>
                  ) : (
                    "Yes, Upload"
                  )}
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        )}
      </Container>
    );
  }
}

export default withRouter(
  compose(
    graphql(FETCH_EXAMNAMES, {
      options: (props) => ({
        variables: {
          institute_id: parseInt(Cookies.get("institutionid")),
        },
      }),
      name: "getExamNames",
    }),
    graphql(OMR_UPLOAD, { name: "omrupload" })
  )(NewOmrUpload)
);
